<template>
    <div>
        <sui-message class="negative" v-if="activeGateway.isUsed">
            <p>
                <sui-icon color="red" name="exclamation triangle"/>
                {{ $t('gateway.form.unableToDelete') }}
            </p>
        </sui-message>
        <sui-button color="red" @click.native="deleteGateway" :disabled="activeGateway.isUsed">
            {{ $t('common.delete') }}
        </sui-button>
    </div>
</template>

<script>
    import store from '@/store';
    import { mapGetters } from 'vuex';

    export default {
        name: 'GatewayActions',
        components: {},
        beforeMount() {
            store.commit('setActiveGateway');
        },
        beforeDestroy() {
            store.commit('setActiveGateway');
            store.commit('removeAppTitle');
        },
        mounted() {
            store.commit('setAppTitle', `${this.$t('common.actions')}`);
        },
        async created() {
            this.isLoading = true;

            await store.dispatch('getGatewayById', this.$route.params.gateway_id);

            store.commit('setAppTitle', `${this.$t('common.actions')} - ${this.activeGateway.name}`);

            this.isLoading = false;
        },
        data() {
            return {
                isLoading: false,
                state: store.state,
                gatewayId: this.$route.params.gateway_id,
            }
        },
        computed: {
            ...mapGetters(['activeGateway']),
        },
        methods: {
            async deleteGateway() {
                await store.dispatch('removeGateway', this.activeGateway.id);
                this.$router.push({ name: 'GatewaysList' });
            }
        }
    }
</script>
